import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import ChatbotContent from './ChatbotContent';

const FloatingChatButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating button - fixed on the right */}
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-teal-500 to-emerald-600 text-white shadow-lg shadow-teal-500/30 hover:from-teal-600 hover:to-emerald-700 hover:shadow-xl hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 bottom-[5.5rem]"
        aria-label="Ouvrir l'assistant"
      >
        <MessageSquare className="w-7 h-7" />
      </button>

      {/* Slide-over panel */}
      {open && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-40 backdrop-blur-sm"
            aria-hidden="true"
            onClick={() => setOpen(false)}
          />
          <div
            className="fixed top-0 right-0 bottom-0 w-full max-w-md bg-white dark:bg-gray-900 shadow-2xl z-50 flex flex-col"
            style={{
              boxShadow: '-4px 0 24px rgba(0,0,0,0.15)',
              animation: 'slideIn 0.3s ease-out',
            }}
            role="dialog"
            aria-label="Assistant chat"
          >
            <ChatbotContent compact onClose={() => setOpen(false)} />
          </div>
        </>
      )}

      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
    </>
  );
};

export default FloatingChatButton;
